import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Styles from "./styles.module.scss";
import userImages1 from "../../assets/images/user/anjali-pic-01.png"; 
import userImages2 from "../../assets/images/user/user-pic-01.png"; 
import userImages3 from "../../assets/images/user/user-pic-03.png"; 
import "./slick.scss";
import { ImageUrl } from "../../utils/CONSTANTS";
// import {detailsAPI} from "../../utils/CONSTANTS"
import { getAPI } from "../../api/apis";
import { useState } from "react";

function Testimonial() {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    useEffect(() => {
        getAPI('https://ellow-dev-static-content.s3.ap-south-1.amazonaws.com/details.json').then((response) => {
            // setValue(response)
        })
    }
        , [])



    return (
       <div className={Styles.sliderWrapper}>
        <Slider {...settings} >
            <div className={Styles.sliderCard}>
                <img src={userImages1} alt="avatar"/>
                <h3>Anjali S</h3>
                <p>Product Manager, India</p>
                <div className={Styles.para}>
                "is an experienced project and product manager with a demonstrated history of working in e-commerce as well as in the health industries. Through ellow , I could showcase my expertise in  project management, planning and scrum, especially in handling the team during the development"
                </div>
            </div>
            <div className={Styles.sliderCard}>
                <img src={userImages2} alt="avatar"/>
                <h3>Gabriel Joseph </h3>
                <p>Senior Reactjs Developer , USA</p>
                <div className={Styles.para}>
                    “ellow helped me to work on a range of products and clients, helping launch many new applications. I could be a part of leading companies by creating an easy development environment, fixing technical debts, providing best practices code examples, and mentoring devs.Thanks to ellow team!”
                </div>
            </div>
            <div className={Styles.sliderCard}>
                <img src={userImages3} alt="avatar"/>
                <h3>Emma Lopez</h3>
                <p>Information Architecture Designer, Canada</p>
                <div className={Styles.para}>
                    “is a highly experienced and successful product, UX,UI, visual and branding designer with many years of experience in creating large and small scale designs. ellow helped me to shake hands with many companies and startups in diverse sectors”
                </div>
            </div>
        </Slider>
      </div>
    );
}


export default Testimonial;